import { QueryClientProvider } from '@tanstack/react-query';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';

import { OpsPortal } from './ops-portal';
import { queryClient } from './query-client';
import { theme } from './theme';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <OpsPortal />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
